const getDates = {
  fixISOStringDateToPost: function (sendDate) {
    const date = new Date(sendDate);
    date.setMilliseconds(0);
    const ISOStringDate = date.toISOString();

    return ISOStringDate.replace(".000Z", "");
  },
  fixDateToUtcPostfix: function (date) {
    return date.replace("Z", " +00:00");
  },
  getDateFromUtc: function (dateUtc) {
    return new Date(dateUtc);
  },
  setDateToUtcNumber: function (date) {
    return Date.parse(date) ? date.getTime() : date;
  },
  setDateToUtcISOString: function (date) {
    return date.toISOString();
  },
  getDateFormat1: function (date) {
    const dates = parseStringToDate(date),
      monthName = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"];

    return dates.day + " " + monthName[dates.month] + " " + dates.year;
  },
  getDateFormat2: function (date) {
    const dates = parseStringToDate(date);
    return lessTen(dates.day) + "." + lessTen(++dates.month) + "." + dates.year;
  },
  getDateFormat3: function (date) {
    const dates = parseStringToDate(date);
    return (
      lessTen(dates.day) +
      "." +
      lessTen(++dates.month) +
      "." +
      dates.year +
      " " +
      lessTen(dates.hour) +
      ":" +
      lessTen(dates.min) +
      ":" +
      lessTen(dates.sec)
    );
  },
  getDateFormat4: function (date) {
    const dates = parseStringToDate(date);
    return lessTen(dates.day) + "." + lessTen(++dates.month) + "." + dates.year + ", " + lessTen(dates.hour) + ":" + lessTen(dates.min);
  },
  getDateFormat5: function (date) {
    const dates = parseStringToDate(date);
    return lessTen(dates.day) + "." + lessTen(++dates.month) + " " + "в" + " " + lessTen(dates.hour) + ":" + lessTen(dates.min);
  },
  getDateFormat6: function (date) {
    const dates = parseStringToDate(date);
    return lessTen(dates.day) + "." + lessTen(++dates.month);
  },
  getDateFormat7: function (date) {
    const dates = parseStringToDate(date);
    return (
      lessTen(dates.year) +
      "-" +
      lessTen(++dates.month) +
      "-" +
      dates.day +
      "T" +
      lessTen(dates.hour) +
      ":" +
      lessTen(dates.min) +
      ":" +
      lessTen(dates.sec)
    );
  },

  getDateFormat8: function (date) {
    const dates = parseStringToDate(date);
    return lessTen(dates.day) + "." + lessTen(++dates.month) + "." + dates.year + " " + lessTen(dates.hour) + ":" + lessTen(dates.min);
  },
  getDateFormat9: function (date) {
    const dates = parseStringToDate(date);
    return (
      lessTen(dates.day) +
      "." +
      lessTen(++dates.month) +
      "." +
      lessTen(dates.year) +
      " " +
      lessTen(dates.hour) +
      ":" +
      lessTen(dates.min) +
      ":" +
      lessTen(dates.sec)
    );
  },
  getDateFormat10: function (date) {
    const dates = parseStringToDate(date);
    return (
      lessTen(dates.day) +
      "." +
      lessTen(++dates.month) +
      "." +
      dates.year +
      " " +
      lessTen(dates.hour) +
      ":" +
      lessTen(dates.min) +
      ":" +
      lessTen(dates.sec) +
      "." +
      lessHundred(dates.millisec)
    );
  },
  getDateFormat11: function (date) {
    const dates = parseStringToDate(date);
    return (
      dates.year +
      "-" +
      lessTen(++dates.month) +
      "-" +
      lessTen(dates.day) +
      " " +
      lessTen(dates.hour) +
      ":" +
      lessTen(dates.min) +
      ":" +
      lessTen(dates.sec)
    );
  },
  getDateFormat12: function (date) {
    const dates = parseStringToDate(date);
    return (
      lessTen(dates.year) +
      "-" +
      lessTen(++dates.month) +
      "-" +
      lessTen(dates.day) +
      " " +
      lessTen(dates.hour) +
      ":" +
      lessTen(dates.min) +
      ":" +
      lessTen(dates.sec)
    );
  },

  getDateFormat13: function (date) {
    const dates = parseStringToDate(date);
    return `${lessTen(dates.year)}${lessTen(++dates.month)}${lessTen(dates.day)}${lessTen(dates.hour)}${lessTen(dates.min)}00`;
  },
  getDateFormat14: function (date) {
    const dates = parseStringToDate(date);
    return (
      lessTen(dates.day) + "." + lessTen(++dates.month) + "." + lessTen(dates.year) + " " + lessTen(dates.hour) + ":" + lessTen(dates.min)
    );
  },
  getDateFormat15: function (date) {
    const dates = parseStringToDate(date);
    return (
      lessTen(dates.year) +
      "-" +
      lessTen(++dates.month) +
      "-" +
      lessTen(dates.day) +
      "T" +
      lessTen(dates.hour) +
      ":" +
      lessTen(dates.min) +
      ":" +
      lessTen(dates.sec) +
      "Z"
    );
  },
  getUrlDate: function (date) {
    const thisDate = new Date(date);
    thisDate.setHours(0, 0, 0, 0);

    return this.fixISOStringDateToPost(thisDate);
  },
  getLocalDate: function (date) {
    let utcDate = new Date(date);
    let localDate = new Date(
      Date.UTC(
        utcDate.getFullYear(),
        utcDate.getMonth(),
        utcDate.getDate(),
        utcDate.getHours(),
        utcDate.getMinutes(),
        utcDate.getSeconds(),
      ),
    );

    return localDate;
  },
  getTimeFormat1: function (date) {
    const dates = parseStringToDate(date);

    return lessTen(dates.hour) + ":" + lessTen(dates.min);
  },
  getTimeFormat2: function (date) {
    const dates = parseStringToDate(date);

    return lessTen(dates.hour) + ":" + lessTen(dates.min) + ":" + lessTen(dates.sec);
  },
  getNullTimeDate: function (inDate) {
    let date = new Date(inDate);

    date.setHours(0, 0, 0, 0);

    return date;
  },
  getNullTimeDateUtcNumber: function (inDate) {
    let date = new Date(inDate);

    date.setHours(0, 0, 0, 0);

    return date.getTime();
  },
  getNullMinTimeDateUtcNumber: function (inDate) {
    let date = new Date(inDate);

    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date.getTime();
  },
  getNullSecMsecTimeDateUtcNumber: function (inDate) {
    let date = new Date(inDate);

    date.setSeconds(0);
    date.setMilliseconds(0);

    return date.getTime();
  },
  getNullMsecTimeDateUtcNumber: function (inDate) {
    let date = new Date(inDate);

    date.setMilliseconds(0);

    return date.getTime();
  },
  getEndDayTimeDate: function (inDate) {
    let date = new Date(inDate);

    date.setHours(23, 59, 59, 999);

    return date;
  },
  getTimeZone: function () {
    return new Date().getTimezoneOffset() / -60;
  },
  getTimeLong: function (start, finish) {
    const oneSecond = 1000;
    let between = Math.floor((new Date(finish).getTime() - new Date(start).getTime()) / oneSecond);
    let hoursLong = Math.floor(between / 60 / 60);
    let minuteLong = Math.floor((between - hoursLong * 60 * 60) / 60);
    let secondLong = between - hoursLong * 60 * 60 - minuteLong * 60;
    let days = Math.trunc(hoursLong / 24);
    hoursLong = Math.abs(days * 24 - hoursLong);

    return (days > 0 ? days + " д " : "") + hoursLong + " ч " + minuteLong + " мин " + secondLong + " сек";
  },
  getDayOfWeekFormat1: function (dateString) {
    const values = dateString.split(".");
    const date = new Date(`${values[2]}-${values[1]}-${values[0]}`);

    const days = ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"];

    return days[date.getDay()];
  },
  getDayOfWeekFormat2: function (dateString) {
    const values = dateString.split(".");
    const date = new Date(`${values[2]}-${values[1]}-${values[0]}`);

    const days = ["Вс.", "Пн.", "Вт.", "Ср.", "Чт.", "Пт.", "Сб."];

    return days[date.getDay()];
  },
  concat: function (date, time) {
    const dateTime = new Date(date);
    const _time = new Date(time);
    dateTime.setHours(_time.getHours());
    dateTime.setMinutes(_time.getMinutes());

    return dateTime;
  },
  timeStringToLocalString(value) {
    const offset = this.getTimeZone();
    const vales = value.split(":");
    let hours = Number(vales[0]) + offset;

    if (hours > 23) {
      hours = hours - 24;
    }

    return `${lessTen(hours)}:${vales[1]}`;
  },
  timeStringToUtcString(value) {
    const offset = this.getTimeZone();
    const vales = value.split(":");
    let hours = Number(vales[0]) - offset;

    if (hours < 0) {
      hours = 24 + hours;
    }

    return `${lessTen(hours)}:${lessTen(Number(vales[1]))}:00`;
  },

  hoursAndMinutes(value) {
    const vales = value.split(":");

    return `${vales[0]}:${vales[1]}`;
  },

  timeAddMinuts(time, duration) {
    if (duration === 0) return time;

    const vales = time.split(":");

    let hours = Number(vales[0]);
    let minutes = Number(vales[1]);

    let _hours = Math.floor(duration / 60);
    let _minutes = duration - Math.floor(duration / 60) * 60;

    minutes += _minutes;

    if (minutes > 59) {
      hours++;
      minutes = minutes - 60;
    }

    hours += _hours;

    if (hours > 23) {
      hours = hours - 24;
    }

    return `${lessTen(hours)}:${lessTen(minutes)}`;
  },

  lessTenValue(value) {
    return lessTen(value);
  },
  equalsForMinutes(date, otherDate) {
    return (
      date.getFullYear() === otherDate.getFullYear() &&
      date.getMonth() === otherDate.getMonth() &&
      date.getDay() === otherDate.getDay() &&
      date.getHours() === otherDate.getHours() &&
      date.getMinutes() === otherDate.getMinutes()
    );
  },
};

const parseStringToDate = function (date) {
  const thisDate = new Date(date);
  return parseDate(thisDate);
};

const parseDate = function (thisDate) {
  return {
    day: thisDate.getDate(),
    month: thisDate.getMonth(),
    year: thisDate.getFullYear(),
    hour: thisDate.getHours(),
    min: thisDate.getMinutes(),
    sec: thisDate.getSeconds(),
    millisec: thisDate.getMilliseconds(),
  };
};

const lessTen = function (n) {
  return n < 10 ? "0" + n : n;
};

const lessHundred = function (n) {
  return n < 10 ? "00" + n : n < 100 ? "0" + n : n;
};

export default getDates;
